import { gql } from '@apollo/client'

export const GET_TASK_TEMPLATES = gql`
  query GetTaskTemplates(
    $pageInfo: PageInfoInput
    $orderBy: OrderByInput
    $search: String
  ) {
    taskTemplates(pageInfo: $pageInfo, orderBy: $orderBy, search: $search) {
      items {
        taskTemplateId
        title
        createdAt
        updatedAt
        createdBy {
          employeeId
          firstName
          lastName
        }
      }
      totalCount
      pageInfo {
        limit
        offset
      }
    }
  }
`

export const GET_TASK_TEMPLATE = gql`
  query GetTaskTemplate($taskTemplateId: String!) {
    taskTemplate(taskTemplateId: $taskTemplateId) {
      taskTemplateId
      title
      description
      type
      priority
      defaultDueInHours
      defaultReminderInHours
      includeAssignedEmployee
      assignees {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const CREATE_TASK_TEMPLATE = gql`
  mutation CreateTaskTemplate($input: CreateTaskTemplateInput!) {
    createTaskTemplate(input: $input) {
      taskTemplateId
      title
      description
      type
      priority
      defaultDueInHours
      defaultReminderInHours
      includeAssignedEmployee
    }
  }
`

export const UPDATE_TASK_TEMPLATE = gql`
  mutation UpdateTaskTemplate(
    $taskTemplateId: String!
    $input: UpdateTaskTemplateInput!
  ) {
    updateTaskTemplate(taskTemplateId: $taskTemplateId, input: $input) {
      taskTemplateId
      title
      description
      type
      priority
      defaultDueInHours
      defaultReminderInHours
      includeAssignedEmployee
    }
  }
`

export const DELETE_TASK_TEMPLATE = gql`
  mutation DeleteTaskTemplate($taskTemplateId: String!) {
    deleteTaskTemplate(taskTemplateId: $taskTemplateId) {
      taskTemplateId
    }
  }
`
